import { FC, useCallback } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { generateEmptyCategory } from "../../../../../utils/helpers/generateEmptyCategory";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  addNewCategory,
  updateSharedCost,
} from "@/store/dimensions/dimensionsSlice";
import { categoriesCreationDataIsInvalidSelector } from "@/store/dimensions/selectors/options/categories/categoriesCreationDataIsInvalidSelector";
import { dimensionCategoriesLengthSelector } from "@/store/dimensions/selectors/slice-data/categories/dimensionCategoriesLengthSelector";
import { dimensionSharedCostsSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsSelector";
import { DimensionCategories } from "@/store/dimensions/utils/types/common";

export const AddCategoryButton: FC = () => {
  const dispatch = useAppDispatch();
  const disabled = useAppSelector(categoriesCreationDataIsInvalidSelector);
  const categoriesLength = useAppSelector(dimensionCategoriesLengthSelector);
  const sharedCosts = useAppSelector(dimensionSharedCostsSelector);

  const updateSharedCostsByNewCategory = useCallback(
    (categories: DimensionCategories) => {
      sharedCosts.forEach((sharedCost) => {
        if (sharedCost.distribution_type === "even") {
          return;
        }

        const newCategoryId = Object.keys(categories).at(0);

        if (!newCategoryId) {
          return;
        }

        dispatch(
          updateSharedCost({
            ...sharedCost,
            share_amounts: [
              ...(sharedCost.share_amounts ?? []),
              { share_amount: 0, category_id: newCategoryId },
            ],
          }),
        );
      });
    },
    [sharedCosts, dispatch],
  );

  const addCategoryHandler = useCallback(() => {
    const newCategories = generateEmptyCategory(categoriesLength);

    dispatch(addNewCategory(newCategories));
    updateSharedCostsByNewCategory(newCategories);
  }, [dispatch, updateSharedCostsByNewCategory, categoriesLength]);

  return (
    <Button
      variant="outlined"
      disabled={disabled}
      startIcon={<AddIcon />}
      onClick={addCategoryHandler}
      sx={{ alignSelf: "start" }}
    >
      Add Category
    </Button>
  );
};
